/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Route } from 'react-router-dom';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { useTheme } from '../../context/theme-context';

import styles from './LandingScreen.module.scss';

const LandingLayout = ({ children }) => {
  const { getCurrentTheme } = useTheme();
  const {
    homepage_image,
    homepage_variant,
    homepage_position
  } = getCurrentTheme();
  const mainContainerClasses = cx(styles.main, {
    [styles.left]: homepage_variant === 'left'
  });

  return (
    <div className={styles.content_container}>
      <main
        className={mainContainerClasses}
        data-testid="login-screen"
        style={{
          backgroundImage: `url(${homepage_image})`,
          backgroundPosition: homepage_position
        }}
      >
        <div className={styles['landing-container']}>{children}</div>
      </main>
    </div>
  );
};

const LandingScreenRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(matchProps) => (
      <LandingLayout>
        <Component {...matchProps} />
      </LandingLayout>
    )}
  />
);

LandingScreenRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

LandingScreenRoute.defaultProps = {
  component: null
};

LandingLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default LandingScreenRoute;
